export const daysAgo = (date: string | Date): string | null => {
  date = new Date(date);
  if (date) {
    const currentDate = new Date();
    const timeDifference = currentDate.getTime() - date.getTime();
    const daysAgo = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    return `${daysAgo} days ago`;
  }
  return null;
};
